import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-auth-card-header',
  templateUrl: './auth-card-header.component.html'
})
export class AuthCardHeaderComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
